/** An aerodrome (or other site) the signed-in principal can see — one row of the console bootstrap. */
export interface Site {
  id: string;
  code: string; // ICAO, e.g. OEMA
  name: string;
  timezone?: string;
  /** Site centroid, WGS-84. */
  centre?: { lon: number; lat: number };
  assets?: number;
  /** Open counts from the console bootstrap; used to pick the busiest site. */
  counts?: {
    openDefects: number;
    openWorkOrders: number;
    openAlerts: number;
  };
}

/**
 * The console opens on the site carrying the most open work, not the
 * alphabetically first one. A duty manager with several aerodromes on one
 * licence should not have to go looking for the one with open alerts.
 */
export function busiestSite(sites: readonly Site[]): Site | undefined {
  if (!sites.length) return undefined;
  return [...sites].sort((a, b) => openWork(b) - openWork(a))[0];
}

function openWork(s: Site): number {
  const c = s.counts;
  return c ? c.openAlerts * 3 + c.openWorkOrders + c.openDefects : 0;
}
